import { ProteinFormulationData } from 'business/models/Layer';
import React, { useMemo } from 'react';
import {
  EPrecisionType,
  PrecisionFormatter,
} from 'components/plateviewer/render/plate/plateviewer/constants';

interface ProteinDetailsCardProps {
  protein: ProteinFormulationData;
  formatWithPrecision: PrecisionFormatter;
}

export const ProteinDetailsCard = ({
  protein,
  formatWithPrecision,
}: ProteinDetailsCardProps) => {
  const proteinDetails = useMemo(() => {
    return [
      {
        label: 'Drop Protein Volume:',
        value:
          protein.dropProteinVolume != null
            ? `${formatWithPrecision(
                protein.dropProteinVolume,
                EPrecisionType.Volume,
              )} µL`
            : null,
      },
      {
        label: 'Well Volume:',
        value:
          protein.dropWellVolume != null
            ? `${formatWithPrecision(protein.dropWellVolume, EPrecisionType.Volume)} µL`
            : null,
      },
      { label: 'Protein Lot ID:', value: protein.proteinLotId },
      {
        label: 'Volume (µL):',
        value:
          protein.volume != null
            ? formatWithPrecision(protein.volume, EPrecisionType.Volume)
            : null,
      },
      {
        label: 'Storage Temp. (°C):',
        value: protein.storageTemp != null ? protein.storageTemp : null,
      },
      { label: 'Class:', value: protein.pclass },
      { label: 'Ext. Coefficient:', value: protein.extCoefficient },
    ].filter((row) => row.value != null && row.value !== '');
  }, [protein, formatWithPrecision]);

  return (
    <div className="flex flex-col gap-1 p-3 mt-2 text-sm bg-[#FAFAFA] rounded-lg">
      {proteinDetails.map((row) => (
        <div key={row.label} className="flex flex-row">
          <span className="w-2/5 font-normal text-[#5D5D5D] text-xs font-[Roboto]">
            {row.label}
          </span>
          <span className="w-3/5 text-xs font-[Roboto]">{row.value}</span>
        </div>
      ))}
    </div>
  );
};
